export default __webpack_public_path__ + "static/media/musicapp.a9ed9bb6.png";